import { generatePath, useNavigate } from 'react-router'
import { StationTabValue } from '../pages/stations/station.page'
import { WoolDataTabValue } from '../pages/stations/wool-data/station-wool-data.page'
import { OffersTabValue } from '../pages/offers/offers.page'
import { routes } from '@/routing/routes'

type RouteDefinition = {
  path: string
}

export function useNavigation() {
  const navigate = useNavigate()

  const navigateTo = (route: RouteDefinition, params = {}) => {
    const path = generatePath(route.path, params)
    navigate(path)
  }

  const navigateToNewSpeci = (stationRecordNumber: string, speciId: string) => {
    navigateTo(routes.newSpeci, { stationRecordNumber, speciId })
  }
  const navigateToEditSpeci = (stationRecordNumber: string, speciId: string) => {
    navigateTo(routes.editSpeci, { stationRecordNumber, speciId })
  }
  const navigateToViewSpeci = (stationRecordNumber: string, speciId: string) => {
    navigateTo(routes.viewSpeci, { stationRecordNumber, speciId })
  }
  const navigateToAnyTab = (
    stationRecordNumber: string | null,
    stationTabValue?: string,
    woolDataTabValue?: string
  ) => {
    // Only the wool data station table value needs a wool data (sub)tab value
    if (stationTabValue === StationTabValue.WOOL_DATA) {
      navigateTo(routes.woolDataTab, {
        stationRecordNumber,
        stationTabValue,
        woolDataTabValue,
      })
    } else {
      navigateTo(routes.stationPageTab, { stationRecordNumber, stationTabValue })
    }
  }
  const navigateToWoolDataTab = (stationRecordNumber: string, woolDataTabValue: string) => {
    navigateTo(routes.woolDataTab, {
      stationRecordNumber,
      stationTabValue: StationTabValue.WOOL_DATA,
      woolDataTabValue,
    })
  }
  const navigateToWoolContracts = (stationRecordNumber: string) => {
    navigateToWoolDataTab(stationRecordNumber, WoolDataTabValue.WOOL_CONTRACTS)
  }
  const navigateToOffers = (stationRecordNumber: string) => {
    navigateTo(routes.offers, { stationRecordNumber })
  }
  const navigateToStationSpecis = (stationRecordNumber?: string) => {
    navigateToStationTab(stationRecordNumber, StationTabValue.SPECIFICATIONS)
  }
  const navigateToStationOffers = (stationRecordNumber: string) => {
    navigateToStationTab(stationRecordNumber, StationTabValue.OFFERS)
  }
  const navigateToStationDetails = (stationRecordNumber: string) => {
    navigateToStationTab(stationRecordNumber, StationTabValue.DETAILS)
  }
  const navigateToStationWoolData = (stationRecordNumber: string) => {
    navigateToStationTab(stationRecordNumber, StationTabValue.WOOL_DATA)
  }
  const navigateToStationTab = (stationRecordNumber?: string, stationTabValue?: string | null) => {
    navigateTo(routes.stationPageTab, { stationRecordNumber, stationTabValue })
  }
  const navigateToUnsoldLots = () => {
    navigateTo(routes.offersTab, { offersTabValue: OffersTabValue.UNSOLD_LOTS })
  }
  const navigateToOffersTab = (offersTabValue: string | null) => {
    navigateTo(routes.offersTab, { offersTabValue })
  }
  const navigateToViewOffers = () => {
    navigateTo(routes.offersTab, { offersTabValue: OffersTabValue.VIEW_OFFERS })
  }
  const navigateToViewOffer = (offerId: string) => {
    navigateTo(routes.viewOffer, { offerId })
  }
  const navigateToNewOffer = () => {
    navigateTo(routes.newOffer)
  }
  const navigateToWoolStoreTools = () => {
    navigateTo(routes.woolStoreTools)
  }
  const navigateToTypingProgram = () => {
    navigateTo(routes.typingProgram)
  }
  const navigateToTypedLots = () => {
    navigateTo(routes.typedLots)
  }
  const navigateToHome = () => {
    navigateTo(routes.home)
  }

  return {
    navigateToHome,
    navigateToNewSpeci,
    navigateToEditSpeci,
    navigateToViewSpeci,
    navigateToWoolDataTab,
    navigateToWoolContracts,
    navigateToOffers,
    navigateToNewOffer,
    navigateToOffersTab,
    navigateToStationSpecis,
    navigateToStationOffers,
    navigateToStationDetails,
    navigateToStationWoolData,
    navigateToUnsoldLots,
    navigateToViewOffers,
    navigateToViewOffer,
    navigateToWoolStoreTools,
    navigateToTypingProgram,
    navigateToTypedLots,
    navigateToStationTab,
    navigateToAnyTab,
  }
}
